<template>
	<button
		class="am-button"
		:class="[
			`am-button--${theme}`,
			`am-button--${size}`,
			{
				'is-filled': filled,
				'is-borderless': borderless
			}
		]"
		@click="$emit('click', $event)"
	>
		<am-icon class="am-button__icon" :name="icon" :dark="filled" :theme="theme" size="sm" />

		<am-text class="am-button__text" type="button" :dark="filled" :theme="theme">
			<slot>
			</slot>
		</am-text>
	</button>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMIcon from '@/components/atoms/AMIcon'

export default {
	components: {
		'am-text': AMText,
		'am-icon': AMIcon,
	},

	props: {
		theme: {
			type: String,
			default: 'primary' // primary | secondary
		},
		icon: {
			type: String,
			default: null
		},
		filled: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'md' // sm | md | lg
		},
		borderless: {
			type: Boolean,
			default: false
		},
		link: {
			type: String,
			default: null
		}
	}
}
</script>

<style lang="scss">
.am-button{
	height: 44px;
	border-radius: 44px;
	padding: 8px 32px;
	border: 1px solid #99887F;
	cursor: pointer;
	outline: none;
	display: flex;
	align-items: center;
	transition: .15s $easeInOutQuad;
	&__icon{
		margin-right: 8px;
		transition: .15s $easeInOutQuad;
	}
	&__text{
		transition: .15s $easeInOutQuad;
	}

	&:not(.is-filled){
		color: #99887F;
		background: white;
		&:hover{
			background: $c-light-brown;
			border-color: $c-light-brown;
			.am-icon,
			.am-text{
				color: white;
			}
		}
	}

	&.is-filled{
		background: $c-light-brown;
		border-color: $c-light-brown;
		color: white;
		&:hover{
			background: $c-brown;
			border-color: $c-brown;
		}
	}
}
</style>
